import {h} from 'preact';
import Icon from '@components/common/Icon';

const ReviewStatusLabel = ( {status} ) => {
    if ( status === 1 ) {
        return null;
    }

    let label, icon;

    switch ( status ) {
        case 2:
            label = 'Denied/Unpublished';
            icon = 'remove';
            break;
        case 0:
            label = 'Pending';
            icon = 'report-problem-triangle';
            break;

        default:
            return null
    }

    return (
        <div className="flex items-center" data-testid="test-reviewStatusLabel">
            <Icon.ui name={icon} center className="mr-2 text-md"/>
            <strong className="text-base">{label}</strong>
        </div>
    );
};

export default ReviewStatusLabel;